import pino, { type Logger as PinoLogger } from "pino";
import logConfig from "../../lib/log-config.cjs";

type AppLogger = Pick<
  PinoLogger,
  "fatal" | "error" | "warn" | "info" | "debug" | "trace" | "child"
>;

let cachedLogger: AppLogger | null = null;

function createServerLogger(): AppLogger {
  // Use plain JSON output to avoid worker-based transports in RSC
  const logger = pino(logConfig);

  return logger as unknown as AppLogger;
}

function createBrowserLogger(): AppLogger {
  // Lightweight console-backed logger for the browser to avoid bundling pino transports
  const delegate = console;
  return {
    fatal: (...args: unknown[]) => delegate.error(...args),
    error: (...args: unknown[]) => delegate.error(...args),
    warn: (...args: unknown[]) => delegate.warn(...args),
    info: (...args: unknown[]) => delegate.info(...args),
    debug: (...args: unknown[]) => delegate.debug(...args),
    trace: (...args: unknown[]) => delegate.trace(...args),
    child: () => createBrowserLogger(),
  } as unknown as AppLogger;
}

export const logger: AppLogger = (() => {
  if (cachedLogger) return cachedLogger;
  const isBrowser = typeof window !== "undefined";
  cachedLogger = isBrowser ? createBrowserLogger() : createServerLogger();
  return cachedLogger;
})();

export type { AppLogger };
